import type { OBVAnalyzerEvent } from '@einhaus/project314-types';
import Card from '@/components/UI/Card';
import { formatEnumLabel } from './helpers';
import type { ObvEventCountRow } from './types';

interface EventDistributionCardProps {
    eventCounts: ObvEventCountRow[];
    onToggleEventType: (eventType: OBVAnalyzerEvent['type']) => void;
    resolvedSelectedEventTypes: Set<OBVAnalyzerEvent['type']>;
}

const EventDistributionCard = ({ eventCounts, onToggleEventType, resolvedSelectedEventTypes }: EventDistributionCardProps) => (
    <Card responsivePadding bodyClassName="space-y-4" title="Event Distribution">
        {eventCounts.length === 0 ? (
            <div className="text-sm text-zinc-400">No OBV events were found in the current audit window.</div>
        ) : (
            <div className="space-y-2">
                {eventCounts.map((row) => (
                    <button
                        aria-pressed={resolvedSelectedEventTypes.has(row.type)}
                        className={`flex w-full items-center justify-between rounded-lg border px-3 py-2 text-left text-sm transition-colors ${
                            resolvedSelectedEventTypes.has(row.type)
                                ? 'border-cyan-500/40 bg-cyan-500/10'
                                : 'border-zinc-800 bg-zinc-950/70 hover:bg-zinc-900'
                        }`}
                        key={row.type}
                        type="button"
                        onClick={() => onToggleEventType(row.type)}
                    >
                        <span className="text-zinc-200">{formatEnumLabel(row.type)}</span>
                        <span className="font-medium text-zinc-100">{row.count}</span>
                    </button>
                ))}
            </div>
        )}
    </Card>
);

export default EventDistributionCard;
